import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("g", {
		stroke: "currentcolor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		fill: "none",
		children: /* @__PURE__ */ _jsx("path", { d: "M6.40833 6.39846c0 1.483.58912 2.90523 1.63776 3.95388C9.09473 11.401 10.517 11.99012 12 11.99012s2.90527-.58912 3.95388-1.63778c1.04866-1.04866 1.63778-2.47088 1.63778-3.95388 0-1.483-.58912-2.90527-1.63778-3.95391C14.90526 1.39592 13.483.80679 12 .80679c-1.483 0-2.90527.58912-3.95391 1.63776-1.04863 1.04864-1.63776 2.47091-1.63776 3.95391zM2.85 23.17346c0-2.42672.96402-4.75407 2.67997-6.47007C7.24593 14.98753 9.57327 14.02346 12 14.02346s4.75407.96407 6.47007 2.67993c1.71586 1.716 2.67993 4.04335 2.67993 6.47007" })
	}));
});
export default SvgUser;
